import React, { useEffect, useState } from "react";
import { Box, Slide } from "@mui/material";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import "../Dashboard.css";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import { MenuItem } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { Grid } from "@mui/material";
import VendorEmployees from "./VendorEmployees";
import Visitors from "./Visitors";
import CurrentlyOnsite from "./CurrentlyOnsite";
import ByCompany from "./ByCompany";
import ClientEmployees from "./ClientEmployees";
import axios from "../../../utils/fvAxios";
import BaseUrl from "../../../utils/base-uri.json";
import Sinepro from "./Sinepro";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function OnsiteorOffsite() {
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 50 * 5 + 8,
        width: 200,
      },
    },
  };

  const [Tabvalue, setTabValue] = React.useState(0);
  const ChangeTabs = (event, newValue) => {
    setTabValue(newValue);
  };

  const [businessUnitId, setBusinessUnitId] = useState(1);
  const [businessUnits, setBusinessUnits] = useState(null);
  const [locationId, setLocationId] = useState(1);
  const [locations, setLocations] = useState(null);
  const [clientId, setClientId] = useState(0);
  const [hasPermissions, setHasPermissions] = useState({
    hasSineproPermission: false,
    hasClientEmpPermission: false,
    hasPermission: false,
    hasBadgePermission: false,
  });
  const [HasSineproPermission, setHasSineproPermission] = useState('');
  const [HasClientEmpPermission, setHasClientEmpPermission] = useState('');
  useEffect(() => {
    axios
      .get(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.GetOnsiteOffsite)
      .then((res) => {
        setClientId(res?.data?.data?.clientID);
        setHasPermissions({
          hasSineproPermission: res?.data?.data?.hasSineproPermission,
          hasClientEmpPermission: res?.data?.data?.hasClientEmpPermission,
          hasPermission: res?.data?.data?.hasPermission,
          hasBadgePermission: res?.data?.data?.hasBadgePermission,
        });
        setHasSineproPermission(res?.data?.data?.hasSineproPermission);
        setHasClientEmpPermission(res?.data?.data?.hasClientEmpPermission);
        if (res?.data?.data?.clientID) {
          axios
            .get(
              BaseUrl.baseUrl +
              BaseUrl.OnsiteOffsite.GetClientBusinessUnit +
              "clientID=" +
              res?.data?.data?.clientID
            )
            .then((response) => {
              setBusinessUnits(response?.data?.data);
            });
        }
      });
  }, []);

  const changeBusinessUnit = (value) => {
    setBusinessUnitId(value);
    if (value === 1) {
      setLocationId(value);
    }
    axios
      .get(
        BaseUrl.baseUrl +
        BaseUrl.OnsiteOffsite.GetLocations +
        "businessUnitId=" +
        value
      )
      .then((resp) => {
        setLocations(resp?.data?.data);
      });
  };

  const changeLocation = (value) => {
    setLocationId(value);
  };

  return (
    <>
      <div>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
        >
          <Grid item xs={4} sm={6} md={6} lg={8}>
            <p
              style={{ fontSize: "30px", color: "#3E4A62", marginLeft: "20px" }}
            >
              Onsite / Offsite
            </p>
          </Grid>
          {(Tabvalue === 0 || Tabvalue === 1 || Tabvalue === 2 || Tabvalue === 3) &&
            (
              <>
                <Grid item xs={4} sm={4} md={3} lg={2}>
                  <FormControl sx={{ m: 1, width: 200 }}>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      value={businessUnitId}
                      size="small"
                      onChange={(e) => changeBusinessUnit(e.target.value)}
                      MenuProps={MenuProps}
                    >
                      <MenuItem key={-1} value={1}>
                        Business Unit
                      </MenuItem>
                      {businessUnits &&
                        businessUnits.map((businessUnit) => (
                          <MenuItem
                            key={businessUnit?.id}
                            title={businessUnit.name}
                            value={businessUnit?.id}
                          >
                            {businessUnit?.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
            
                <Grid item xs={4} sm={4} md={3} lg={2}>
                  <FormControl sx={{ m: 1, width: 200 }}>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      value={locationId}
                      disabled={businessUnitId==1}
                      size="small"
                      onChange={(e) => changeLocation(e.target.value)}
                      MenuProps={MenuProps}
                    >
                      <MenuItem key={-1} value={1}>
                        Locations
                      </MenuItem>
                      {locations &&
                        locations.map((location) => (
                          <MenuItem
                            key={location?.businessUnitSiteId}
                            title={location.siteName}
                            value={location?.businessUnitSiteId}
                          >
                            {location?.siteName}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </>
            )
          }
        </Grid>
      </div>
      <Tabs value={Tabvalue} onChange={ChangeTabs} variant="scrollable">
        <Tab
          label="Vendor Employees"
          sx={{ marginLeft: 3 }}
          {...a11yProps(0)}
          style={{ textTransform: "inherit" }}
        />
        <Tab
          label="Visitors"
          {...a11yProps(1)}
          style={{ textTransform: "inherit" }}
        />
        <Tab
          label="Currently Onsite"
          {...a11yProps(2)}
          style={{ textTransform: "inherit" }}
        />
        <Tab
          label="By Company"
          {...a11yProps(3)}
          style={{ textTransform: "inherit" }}
        />
        {/* {hasPermissions.hasClientEmpPermission && ( */}
        <Tab
          hidden={HasClientEmpPermission == false}
          label="Client Employees"
          {...a11yProps(4)}
          style={{ textTransform: "inherit" }}
        />
        {/* )} */}
        {/* {hasPermissions.hasSineproPermission && ( */}
        <Tab
          hidden={HasSineproPermission == false}
          label="Sine Pro Currently Onsite"
          {...a11yProps(5)}
          style={{ textTransform: "inherit" }}
        />
        {/* )} */}
      </Tabs>
      <TabPanel value={Number(Tabvalue)} index={0}>
        <VendorEmployees
          businessUnitId={businessUnitId}
          locationId={locationId}
          clientId={clientId}
          hasBadgePermission={hasPermissions.hasBadgePermission}
          hasPermission={hasPermissions.hasPermission}
        />
      </TabPanel>
      <TabPanel value={Number(Tabvalue)} index={1}>
        <Visitors businessUnitId={businessUnitId} locationId={locationId} />
      </TabPanel>
      <TabPanel value={Number(Tabvalue)} index={2}>
        <CurrentlyOnsite
          businessUnitId={businessUnitId}
          locationId={locationId}
        />
      </TabPanel>
      <TabPanel value={Number(Tabvalue)} index={3}>
        <ByCompany
          businessUnitId={businessUnitId}
          locationId={locationId}
          clientId={clientId}
        />
      </TabPanel>

      <TabPanel value={Number(Tabvalue)} index={4} >
        <ClientEmployees
          clientId={clientId}
          hasBadgePermission={hasPermissions.hasBadgePermission}
          hasPermission={hasPermissions.hasPermission}
        />
      </TabPanel>

      <TabPanel value={Number(Tabvalue)} index={5} >
        <Sinepro />
      </ TabPanel>
    </>
  );
}
